(ns common.schema.entities.tab
  (:require
   [common.schema.schema-utils :as su]))

;; TODO: add more fields and permission checking
(def schema
  (concat
   (su/single-ref-field :tab/current-view
                        "Current view"
                        [:entity.type/view]
                        {})

   (su/single-ref-field :tab/viewed-entity
                        "Viewed entity"
                        ;; TODO: Add more entity types
                        [:entity.type/company]
                        {})

   (su/single-ref-field :tab/ribbon
                        "Ribbon"
                        [:entity.type/ribbon]
                        {})))
